<script setup>
import {computed, ref, onMounted, onUnmounted} from 'vue'
import {useStore} from 'vuex'
import {notify} from "@kyvg/vue3-notification";
import {useRoute} from 'vue-router';

const route = useRoute()
const store = useStore()


onMounted(() => {
  document.body.classList.add('full-width')
})
onUnmounted(() => {
  document.body.classList.remove('full-width')
})


const remember = computed(() => store.getters.remember)

const user = {
  username: remember.value,
  password: "",
  remember: !!remember.value
}
const show_pass = ref(false);

function login(e) {
  e.preventDefault();
  store.dispatch('login', user).then().catch(err => {
    let err_text = 'Данные неверны';
    if (err.response.status === 429) err_text = 'Превышено количество попыток ввода пароля';
    notify({
      type: 'error ',
      title: "Ошибка!",
      text: err_text,
    });

  })
}


</script>

<template>

  <div class="center-form background-gradient">

    <form @submit.prevent="login" class="form-signin">
      <h3 class="h3 mb-3 text-white text-center">Авторизация</h3>

      <div class="form-floating mt-2">
        <input type="email" name="email" class="form-control" autocomplete="on" required v-model="user.username"
               placeholder="Логин">
        <label>Логин</label>
      </div>
      <div class="form-floating password-input mt-2">
        <input class="form-control" id="password" :type="show_pass?'text':'password'" name="password" required
               v-model="user.password" placeholder="Пароль">
        <i v-on:click="show_pass=!show_pass" :class="`bi bi-eye${show_pass?' active':''}`"></i>
        <label>Пароль</label>
      </div>

      <div class="checkbox mb-3 mt-2">
        <input id="id_remember" type="checkbox" v-model="user.remember" value="remember-me">
        <label class="text-white" for="id_remember">
          Запомнить
        </label>
      </div>
      <button class="w-100 btn btn-lg btn-primary text-white" type="submit">Вход</button>
      <div class="forget ">
        <router-link to="/forgot_password/" class="text-center p-2 text-white">Забыли пароль?</router-link>
<!--        |-->
<!--        <router-link to="/registration/" class="text-center p-2 text-white">Регистрация</router-link>-->
      </div>
    </form>


  </div>

</template>

<style scoped lang="scss">
.center-form {

  .form-signin {
    margin: 0 auto;
    background: var(--deep-blue);
    padding: 20px;
    border-radius: 10px;
    max-width: 360px;
    box-shadow: var(--box-shadow);

    .forget {
      display: flex;
      justify-content: space-around;
    }
  }

}

</style>
